import axios from 'axios';
import * as profileService from "./profile";
import {users} from "@atttomyx/shared-utils";
import {userUtils} from "../utils";

export const listUsers = (cursor, limit, success, failure) => {
    let url = "/api/v1/user/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
        .then(response => {
            const json = response.data;

            json.users.forEach(userUtils.sanitizeUser);

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const createUser = (user, success, failure) => {
    const url = "/api/v1/user/";

    axios.post(url, {
        firstName: user.firstName,
        lastName: user.lastName,
        alias: user.alias,
        email: user.email,
        phone: user.phone,
        roles: users.standardizeRoles(user.roles),
        settings: user.settings,
    })
        .then(response => {
            const json = response.data;

            userUtils.sanitizeUser(json);
            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const saveUser = (userId, user, success, failure) => {
    const url = "/api/v1/user/" + userId + "/";

    axios.put(url, {
        firstName: user.firstName,
        lastName: user.lastName,
        alias: user.alias,
        email: user.email,
        phone: user.phone,
        imageUrl: user.imageUrl,
        roles: users.standardizeRoles(user.roles),
        settings: user.settings,
    })
        .then(response => {
            const json = response.data;

            userUtils.sanitizeUser(json);
            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const softDeleteUser = (userId, success, failure) => {
    const url = "/api/v1/user/" + userId + "/soft";

    axios.delete(url)
        .then(response => {
            success(userId);
        })
        .catch(err => {
            failure(err);
        });
};

export const hardDeleteUser = (userId, success, failure) => {
    const url = "/api/v1/user/" + userId + "/hard";

    axios.delete(url)
        .then(response => {
            success(userId);
        })
        .catch(err => {
            failure(err);
        });
};

export const uploadImage = (userId, image, success, failure) => {
    profileService.uploadImage(userId, image, success, failure);
};
